var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibleOd4Flqhi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.829 9.602a2.83 2.83 0 11-5.659 0 2.83 2.83 0 015.659 0z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.602a9.436 9.436 0 0118 0 9.436 9.436 0 01-18 0z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjgyOSA5LjYwMjI2QzEyLjgyOSAxMS4xNjUgMTEuNTYyMiAxMi40MzE4IDkuOTk5NSAxMi40MzE4QzguNDM2NzQgMTIuNDMxOCA3LjE2OTkyIDExLjE2NSA3LjE2OTkyIDkuNjAyMjZDNy4xNjk5MiA4LjAzOTUxIDguNDM2NzQgNi43NzI3MiA5Ljk5OTUgNi43NzI3MkMxMS41NjIyIDYuNzcyNzIgMTIuODI5IDguMDM5NTEgMTIuODI5IDkuNjAyMjZaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMSA5LjYwMjI1QzIuMjAxODYgNS43NzU2NiA1Ljc3Njc5IDMgMTAgM0MxNC4yMjMyIDMgMTcuNzk4MSA1Ljc3NTY5IDE5IDkuNjAyMjVDMTcuNzk4MSAxMy40Mjg4IDE0LjIyMzIgMTYuMjA0NSAxMCAxNi4yMDQ1QzUuNzc2NzggMTYuMjA0NSAyLjIwMTg1IDEzLjQyODggMSA5LjYwMjI1WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgVisibleOd4Flqhi as ReactComponent };